/* @flow */
import Button from 'components/Button.jsx';
import Checkbox from 'components/Checkbox.jsx';
import { dispatcher } from 'lib/Dispatcher';
import Legend from 'components/Legend.jsx';
import { PushEvents } from 'pusher/PusherConstants';
import React from 'react';
import WebNotificationStore from 'notifications/WebNotificationStore';
import WebNotificationTutorialModal from 'notifications/WebNotificationTutorialModal.jsx';
import WebNotificationActions from 'notifications/WebNotificationActions';
import trackView from 'lib/trackView';
import { mountModal } from 'lib/modal';

import 'styles/utilities.scss';

const NotificationSettingsViewDesktop = React.createClass({
  getInitialState() {
    return this.getStateFromStores();
  },

  getStateFromStores() {
    return {
      areNotificationsUserEnabled: WebNotificationStore.areNotificationsUserEnabled(),
    };
  },

  sendTestWebNotification() {
    dispatcher.dispatch({
      type: PushEvents.TEST_MESSAGE,
    });
  },

  updatePermissionState() {
    const areNotificationsUserEnabled = WebNotificationStore.areNotificationsUserEnabled();
    this.setState({ areNotificationsUserEnabled });
  },

  renderButton() {
    const browserPermission = WebNotificationStore.getBrowserPermission();

    if (browserPermission === 'default') {
      return (
        <Button
          size="xsmall"
          level="secondary"
          onClick={() => mountModal(<WebNotificationTutorialModal onRequestHide={this.updatePermissionState} />, this)}
          eventScreenName="desktop_notification"
          eventElementName="desktop_notification_enable">
          Turn on
        </Button>
      );
    } else if (browserPermission === 'granted') {
      const handleChange = (e) => {
        const enabled = e.target.checked;
        WebNotificationActions.updateLocalUserEnabled(enabled);
        this.updatePermissionState();
      };

      return (
        <div
          className="NotificationSettingsView-device">
          <Checkbox
            label="Turn on desktop notifications"
            defaultChecked={this.state.areNotificationsUserEnabled}
            className="block"
            onChange={handleChange}
          />
          <Button
            disabled={!this.state.areNotificationsUserEnabled}
            onClick={this.sendTestWebNotification}
            level="secondary"
            size="xsmall">
            Send test notification
          </Button>
        </div>
      );
    } else if (browserPermission === 'denied') {
      return (
        <p><strong>Re-enable desktop notifications for remind.com in your browser’s settings.</strong></p>
      );
    }

    throw new Error('unknown permission value', browserPermission);
  },

  render() {
    return (
      <div>
        <Legend>
          Desktop
        </Legend>
        {this.renderButton()}
      </div>
    );
  },
});

export { NotificationSettingsViewDesktop };

export default trackView(NotificationSettingsViewDesktop, 'desktop_notification', () => ({
  enabled: WebNotificationStore.getBrowserPermission() === 'granted',
}));



// WEBPACK FOOTER //
// ./src/settings/components/NotificationSettingsViewDesktop.jsx